var site = window.site || {};

(function ($, Drupal) {
  Drupal.behaviors.BambuserBlockV1 = {
    // @IMPORTANT -- Customize me per brand
    getButtons: function ($module, index) {
      var $triggers = $('.js-content-block-link', $module);

      if ($triggers.length) {
        $triggers = $triggers.eq(index - 1);
      }

      return $triggers;
    },

    getImage: function ($module) {
      return $('.mantle-media-asset, .js-how-to-lesson-step-info', $module);
    },

    attach: function (context, settings) {
      var self = this;
      var $modules = $('.js-bambuser-block--v1', context);

      if (!settings.bambuser_source) {
        return false;
      }
      if (!window.initBambuserLiveShopping) {
        window.initBambuserLiveShopping = function (item) {
          window.initBambuserLiveShopping.queue.push(item);
        };
        window.initBambuserLiveShopping.queue = [];
        var scriptNode = document.createElement('script');
        scriptNode.className = 'optanon-category-4';
        scriptNode['src'] = settings.bambuser_source;
        scriptNode['type'] = 'text/plain';

        document.body.appendChild(scriptNode);
      }
      $modules.each(function () {
        self.init($(this));
      });
    },

    init: function ($module) {
      var self = this;
      var index = $module.data('button-index') ? $module.data('button-index') : false;
      var streamId = $module.data('stream-id').trim();
      var linkImage = $module.data('link-image');

      if (linkImage) {
        var $image = self.getImage($module);

        $image.each(function () {
          self.setup($(this), streamId);
        });
      }
      if (index) {
        var $elements = self.getButtons($module, index);

        $elements.each(function () {
          self.setup($(this), streamId);
        });
      }
    },

    setup: function ($elem, streamId) {
      if ((!$elem && $elem.length) || $elem.hasClass('bambuser-initialized')) {
        return false;
      }
      var randomId = 'bambuser-trigger-' + Math.random().toString(36).substr(2, 9);

      if (!$elem.is('a')) {
        $elem.addClass('clickable');
      }
      $elem.attr({
        id: randomId,
        role: 'button',
        tabindex: 0,
        href: 'javascript:void(0);'
      });
      $elem.addClass('bambuser-initialized');
      window.initBambuserLiveShopping({
        showId: streamId,
        node: document.getElementById(randomId),
        type: 'overlay'
      });
      $elem.on('click.activate', function () {
        $(document).trigger('bambuser.launched');
      });
    }
  };
})(jQuery, Drupal);
